import React from 'react';
import PropTypes from 'prop-types';

const Switch = ({ checked, label, name, onChange, tabIndex, disabled }) => {
  const handleOnClick = () => {
    if (disabled) {
      return;
    }
    onChange(!checked);
  };

  return (
    <div
      style={{ visibility: disabled ? 'hidden' : 'visible' }}
      className="switch"
      onClick={handleOnClick}
      tabIndex={tabIndex}
    >
      <span className="switch__label">{label}</span>
      <input
        className="switch__input"
        type="checkbox"
        checked={checked}
        name={name}
        readOnly
      />
      <span className="switch__slider" />
    </div>
  );
};

Switch.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  tabIndex: PropTypes.number,
};

export default Switch;
